import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { useValue } from '../../context/ContextProvider';
import { useNavigate } from 'react-router-dom';
import { getProductos } from '../../actions/productos';
import { Box, Button, Stack, Typography } from '@mui/material';
//import { getDisponibilidad, getImgVentas, getPreciosPan } from '../../actions/tienda';
import { getDisponibilidad, getImgVentas } from '../../actions/tienda';
import PosAdd from './posAdd/PosAdd';
import PosTabla from './posTabla/PosTabla';
import PosButtons from './posButtons/PosButtons';
import { getProveedores } from '../../actions/proveedores';
import ScutInfo from './ScutInfo';

const PointOfSale = () => {
    /* To Do: Cambiar este modelo de permisos por uno que controle el servidor */
    const permisos = ['superusuario', 'administrador', 'cajero'];
    const navigate = useNavigate();
    const { state: { contextLoading, currentUser, productos, proveedores }, dispatch } = useValue();
    const [visibilidad, setVisibilidad] = useState(false);
    const [dispTienda, setDispTienda] = useState([]);           //Disponibilidad de productos en tineda
    //const [preciosPan, setPreciosPan] = useState([]);           //Precios y ofertas de los productos tipo pan
    const [imgVentas, setImgVentas] = useState([]);           //Imagenes para los shortcuts gráficos
    const [alerta, setAlerta] = useState('');
    const [openScutDialog, setOpenScutDialog] = useState(false);

    const [productosOptions, setProductosOptions] = useState([]);
    const [prodSel, setProdSel] = useState([]);
    const [subtotal, setSubtotal] = useState(0);

    const codigoBarrasRef = useRef();

    //===============================================================================================================
    // Obtención de datos iniciales
    //===============================================================================================================
    useEffect(() => {
        //Renderiza la pagina al principio y cuando contextLoading cambia a falso. 
        //Código para hecho para refresh, cambio de páginas y autorizaciones.
        if (contextLoading === false) {
            if (!permisos.includes(currentUser?.tipoUsuario)) {
                dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: 'Página no autorizada! Redirecionando a Inicio.' } });
                navigate('/');
            } else {
                if (productos?.length == 0) {
                    getProductos(currentUser, dispatch);
                    //getLastRowsAlmacen(currentUser, dispatch, setPreciosEnAlmacen);
                } else {
                    if (productos?.length > 0) {
                        const prodOpt = productos.map((producto) => (
                            { id: producto.id, label: producto.product }
                        ));
                        setProductosOptions(prodOpt);
                    } else {
                        //console.log('No products yet')
                    }

                }
                if (proveedores.length == 0) {
                    //console.log('Solicitando Proveedores al servidor.');
                    getProveedores('todo', currentUser, dispatch);
                }
                if (dispTienda?.length == 0) {
                    getDisponibilidad('NINGUNO', currentUser, dispatch, setDispTienda);
                    //console.log({ dispTienda });
                }
                //if (preciosPan?.length == 0) {
                //    getPreciosPan('NINGUNO', currentUser, dispatch, setPreciosPan);
                //    console.log({ preciosPan });
                //}
                if (imgVentas?.length == 0) {
                    getImgVentas('NINGUNO', currentUser, dispatch, setImgVentas);
                    //console.log({ preciosPan });
                }
                setVisibilidad(true);
            }
        } else {
            //console.log('Context not loaded');
        }

    }, [contextLoading, currentUser, productos]);

    useEffect(() => {
        //console.log('useEffect ProdSel');
        // Codigo para recalcular el total de la venta
        if (prodSel?.length > 0) {
            const stot = prodSel.reduce((total, prodSel) => { return total + prodSel.total }, 0);
            setSubtotal(stot);
            //console.log('calculando subtotal: ', stot);
        }

        //Código para reponer el focus a la casilla (input) de codigo de Barras
        //Primero se revisa si el elemento ya fue renderizado, y mediante useRef se accede a él. useRef de este elemento está en el padre y se pasa al hijo como props
        if (codigoBarrasRef.current != undefined) {
            codigoBarrasRef.current.focus();
        }

    }, [prodSel])
    //===============================================================================================================

    const showAlerta = (mensaje) => {
        setAlerta(mensaje);
        setTimeout(() => {
            setAlerta('');
        }, "5000");
    }

    //===============================================================================================================
    // Funcion para añadir o actualizar los productos de tipo PAN
    //===============================================================================================================
    const addPan = (productoEncontrado, n) => {
        //La gestion del pan es diferente al resto de los productos
        //setNombreProductoState(productoEncontrado.nombreProducto);
        //console.log('preciosPan -> ', preciosPan);
        //console.log('productoEncontrado -> ', productoEncontrado);

        let cant = n, cantFinal = 0, totalFinal = 0;

        //Se verifica si el producto ya está en la tabla de Productos Seleccionados
        const prodYaSel = prodSel.find((p) => productoEncontrado.product == p.product);
        if (prodYaSel) {
            //Si el producto ya esta en el array prodSel, se suma n al producto seleccionado
            cant = prodYaSel.cantidad + n;
        }

        //const prePan = preciosPan.find((pp) => pp.product == productoEncontrado.product);
        const prePan = productoEncontrado;
        //console.log({ prePan });
        if (prePan) {
            //Se encontro precio para el producto, e inicialmente se calculan totales en función a lo ingresado por el usuario
            cantFinal = cant;
            //totalFinal = cant * prePan.precio;
            totalFinal = cant * prePan.price;


            //console.log('prePan -> ', prePan);

            //Analiza si el tipo de pan tiene algún esquema de precios 
            //Primero analiza si tiene vendaje
            //if (prePan.vendajeUmbral > 0) {
            if (prePan.vUmbral > 0) {
                //Pan que tiene vendaje
                //const cantMinima = prePan.vendajeUmbral / prePan.precio;    //Calcula la cantidad minima requerida para acceder al vendaje
                const cantMinima = prePan.vUmbral / prePan.price;    //Calcula la cantidad minima requerida para acceder al vendaje
                if (cant >= cantMinima) {
                    //Accede a vendaje
                    //const vendajeCant = prePan.vendajeStep + prePan.vendaje;    //Es la cantidad de panes + el vendaje
                    const vendajeCant = prePan.vStep + prePan.vQty;    //Es la cantidad de panes + el vendaje
                    cantFinal = Math.ceil(cant / vendajeCant) * vendajeCant;      //Calcula la cantidad redondeada con vendaje para el monto pagado
                    //totalFinal = ((cantFinal / vendajeCant) * prePan.vendajeStep) * prePan.precio;
                    totalFinal = ((cantFinal / vendajeCant) * prePan.vStep) * prePan.price;
                }
            } else {
                //no accede a vendaje
                //Segundo.- Analiza si tiene monto por cantidad. Ej. Empanada Negra -> Bs1.5  pero 7 por Bs10
                //if (prePan.comboStep > 0) {
                if (prePan.cStep > 0) {
                    console.log('Pan con Precio por Cantidad')
                    //totalFinal = (Math.floor(cant / prePan.comboStep) * prePan.comboPrecio) + ((cant % prePan.comboStep) * prePan.precio);
                    totalFinal = (Math.floor(cant / prePan.cStep) * prePan.cPrice) + ((cant % prePan.cStep) * prePan.price);
                }
            }

            //Actualiza la tabla
            if (prodYaSel) {
                const newProdVal = { ...prodYaSel, cantidad: cantFinal, total: totalFinal };
                //console.log('Prod Ya Sel: ', newProdVal);
                const newProdSel = prodSel.map((ps) => (
                    ps.product == prodYaSel.product ? newProdVal : ps
                ))
                //console.log({ prodSel });
                setProdSel(newProdSel);
            } else {
                //let newProdSel = [...prodSel, { id: 1, product: prePan.product, price: prePan.precio, cantDisp: 1000, cantidad: cantFinal, total: totalFinal }];
                let newProdSel = [...prodSel, { id: 1, codBar: prePan.codBar, product: prePan.product, price: prePan.price, cantDisp: 1000, cantidad: cantFinal, total: totalFinal }];
                newProdSel = newProdSel.map((p, i) => ({ ...p, id: i + 1 }));
                //console.log('Prod No Sel: ', newProdSel);
                setProdSel(newProdSel);
            }
        } else {
            //No se encontro precio para el producto.  Desplegar mensaje de error
            console.log('Por favor configurar precios para el producto en tipo pan')
        }

        //console.log('codigoBarrasRef.current.focus()');
        //codigoBarrasRef.current.focus();
    }
    //===============================================================================================================


    //===============================================================================================================
    // Funcion para añadir o actualizar los productos de tipo General
    //===============================================================================================================
    const addGeneral = (productoEncontrado, n) => {

        console.log({ productoEncontrado });

        //setNombreProductoState(productoEncontrado.nombreProducto);
        //console.log('dispTienda -> ', dispTienda);
        const prodPrice = productoEncontrado.price;        //Es el precio que se encuentra en la tabla de productos, no en la tabla de tiendaVentas
        //console.log({prodPrice});
        //verifica si el producto está disponible en la tienda
        const dispProd = dispTienda.find((producto) => producto.product == productoEncontrado.product);
        if (dispProd) {
            console.log({ dispProd });

            //Lo adiciona a la tabla de productos a ser vendidos
            const prodYaSel = prodSel.find((p) => dispProd.product == p.product)


            //Si el producto ya esta en el array prodSel, se suma uno al producto seleccionado
            //de lo contrario se añade el producto como una nueva fila
            if (prodYaSel) {
                //console.log({ prodYaSel });
                //verifica que en stock hayan suficientes productos para aumentar la cantidad, no está funcionando bien con shortcut cc3 por ejemplo
                if ((prodYaSel.cantidad + n) <= prodYaSel.cantDisp) {
                    //console.log('Hay mas disponibles');
                    var nuevaCantidad = prodYaSel.cantidad + n;
                } else {
                    nuevaCantidad = prodYaSel.cantDisp; //No hay la cantidad requerida, asi que se ajusta a la cantidad disponible
                    showAlerta("Disponibilidad máxima: " + nuevaCantidad);
                }
                var nuevoTotal = nuevaCantidad * prodYaSel.price;
                const newProdVal = { ...prodYaSel, cantidad: nuevaCantidad, total: nuevoTotal };
                //console.log({ newProdVal })
                const newProdSel = prodSel.map((ps) => (
                    ps.product == prodYaSel.product ? newProdVal : ps
                ))
                //console.log({ prodSel });
                setProdSel(newProdSel);
            } else {
                //Producto aún no seleccionado
                const totDisp = parseInt(dispProd.totalDisponible);
                //console.log({ totDisp, n });
                if (totDisp > 0) {
                    if (n > totDisp) {
                        n = totDisp;
                        showAlerta("Cantidad no Disponible. Disponibilidad: " + n);
                    }
                    //let newProdSel = [...prodSel, { id: 1, product: dispProd.product, price: dispProd.lastPrice, cantDisp: parseInt(dispProd.totalDisponible), cantidad: n, total: parseFloat(dispProd.lastPrice) }];
                    let newProdSel = [...prodSel, { id: 1, codBar: productoEncontrado.codBar, product: dispProd.product, price: prodPrice, cantDisp: parseInt(dispProd.totalDisponible), cantidad: n, total: parseFloat(prodPrice) }];
                    newProdSel = newProdSel.map((p, i) => ({ ...p, id: i + 1 }));
                    setProdSel(newProdSel);
                } else {
                    showAlerta("Producto agotado.");
                }
            }
        } else {
            //El producto existe pero no está disponible en la tienda
            showAlerta("Producto no disponible en tienda.")
        }
    }
    //===============================================================================================================


    //===============================================================================================================
    // Renderización de página
    //===============================================================================================================
    return (
        <>
            {visibilidad ?
                <Fragment>
                    <Stack
                        direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
                        spacing={0}
                        justifyContent={{ lg: 'center' }}
                        flexGrow={1} pt={2} pb={2}
                    >
                        <Box bgcolor='white' borderRight={1} borderColor='divider' flex={7} marginRight={0} padding={1} paddingRight={2} style={{ width: '100%', borderRadius: 0, alignItems: 'center' }} >
                            <PosTabla
                                currentUser={currentUser}
                                dispatch={dispatch}
                                prodSel={prodSel}
                                setProdSel={setProdSel}
                                subtotal={subtotal}
                                dispTienda={dispTienda}
                                setDispTienda={setDispTienda}
                                addPan={addPan}
                                addGeneral={addGeneral}
                                showAlerta={showAlerta}
                            />
                        </Box>

                        <Box bgcolor='white' borderRight={1} borderColor='divider' flex={2} marginRight={0} padding={3} style={{ width: '100%', borderRadius: 0, alignItems: 'center' }} >
                            <PosAdd
                                currentUser={currentUser}
                                dispatch={dispatch}
                                productosOptions={productosOptions}
                                //proveedoresOptions={proveedoresOptions}
                                //dispTienda={dispTienda}
                                //setDispTienda={setDispTienda}
                                //prodSel={prodSel}
                                //setProdSel={setProdSel}
                                //preciosPan={preciosPan}
                                addGeneral={addGeneral}
                                addPan={addPan}
                                codigoBarrasRef={codigoBarrasRef}
                                showAlerta={showAlerta}
                                alerta={alerta}
                                setOpenScutDialog={setOpenScutDialog}
                            />



                        </Box>

                        <Box bgcolor='white' flex={3} padding={1} paddingLeft={2} style={{ borderRadius: 0, width: '100%' }}>
                            <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
                                <PosButtons
                                    imgVentas={imgVentas}
                                    addGeneral={addGeneral}
                                    addPan={addPan}
                                //codigoBarrasRef={codigoBarrasRef}
                                />
                            </Box>
                        </Box>
                    </Stack>

                    <Box bgcolor='orange' borderRadius={0} p={2} mb={0} sx={{ display: 'inline-flex', justifyContent: 'space-between', alignItems: 'center' }} style={{ border: '1px solid #eee', boxShadow: '2px 4px 6px #ddd' }}>
                        <Button onClick={() => setOpenScutDialog(true)} style={{ color: 'blue' }}>
                            Codigos Abreviados
                        </Button>
                        <Typography variant='h6' sx={{ color: 'white' }}>
                            CE Soft 2024
                        </Typography>
                    </Box>

                    <ScutInfo
                        productos={productos}
                        open={openScutDialog}
                        setOpen={setOpenScutDialog}
                    />
                </Fragment>

                :
                <div>Página no autorizada.</div>
            }
        </>
    )
}

export default PointOfSale